import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionsSelectTask } from './SelectTask/ConditionsSelectTask';
import { ConditionsMultiSelectTask } from './ConditionsMultiSelectTask';
import { ConditionsMultiSelectOption } from './ConditionsMultiSelectOption';
import { ConditionsSelectOption } from './SelectTask/ConditionsSelectOption';
export class ConditionsMultiSelect extends ConditionRegistryCategory {
    label = 'MultiSelect';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_t = new ConditionsSelectTask(this);
    c_m = new ConditionsMultiSelectTask(this);
    c_s = new ConditionsSelectOption(this);
    c_o = new ConditionsMultiSelectOption(this);
}
